import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import SourceEditForm from "./Forms/SourceEditForm";
import { TitleAirport } from "./Constant/Source";

const AirportEdit: FC<EditProps> = props => {
  return (
    <Edit {...props} title={TitleAirport.edit} component="div">
      <SourceEditForm {...props} />
    </Edit>
  );
};

export default AirportEdit;
